// extracted by mini-css-extract-plugin
module.exports = {"component":"_3j9iY4zpXRf_SOKa3sESbT","svg":"_2WTmJI534Gj6v1vX_urMs6","verticalSpacing":"_3tOg9F_4B_ujUiFy3P2TVJ","btn":"CAQcyTrhjoUmhJMIR2XJS","primary":"_2DGFwlR1RBFQxp3BThT4xd"};